<div class="px-4 sm:px-6 lg:px-8 py-4 lg:py-8">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-base font-semibold text-fg-primary">
        {{ selectedDate | date: 'd. MMMM yyyy' }}
      </h1>
    </div>
    <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none flex gap-2">
      @if (isToday) {
        <button
          type="button"
          appTailwindButton
          color="white"
          (click)="createTimer.emit(selectedDate)"
        >
          Neuer Timer
        </button>
      }
      <button
        type="button"
        color="secondary"
        appTailwindButton
        (click)="createWorkEntry.emit(selectedDate)"
      >
        Neue Arbeit
      </button>
    </div>
  </div>
  <div class="-mx-4 mt-8 sm:-mx-0">
    <table class="w-full divide-y divide-separator table-fixed">
      <thead>
        <tr>
          <th
            scope="col"
            class="py-3.5 text-left text-sm font-semibold text-fg-primary sm:pl-0 w-16 sm:w-12"
          ></th>
          <th
            scope="col"
            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-fg-primary sm:pl-0"
          >
            Projekt
          </th>
          <th
            scope="col"
            class="hidden px-3 py-3.5 text-left text-sm font-semibold text-fg-primary sm:table-cell"
          >
            Position
          </th>
          <th
            scope="col"
            class="hidden px-3 py-3.5 text-left text-sm font-semibold text-fg-primary lg:table-cell"
          >
            Beschreibung
          </th>
          <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-fg-primary text-right w-20">
            Stunden
          </th>
          <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0 w-32 md:w-60"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-separator bg-surface">
        @for (timerRow of timerRows; track timerRow.timerId) {
          <tr
            app-timer-row
            class="bg-blue-100/15"
            [timer]="timerRow"
            (showTimer)="showTimer.emit($event)"
            (stop)="stop.emit($event)"
            (start)="start.emit($event)"
          ></tr>
        }
        @for (work of works; track work.id) {
          <tr app-work-row [work]="work" (editWork)="editWork.emit($event)"></tr>
        }
        <tr class="hidden lg:table-row">
          <td
            [colSpan]="4"
            class="whitespace-nowrap px-3 py-4 text-sm font-semibold text-fg-primary text-right"
          >
            Total
          </td>
          <td
            class="whitespace-nowrap px-3 py-4 text-sm font-semibold text-fg-primary text-right tabular-nums"
          >
            {{ totalWorkMinutes | formatWork }}
          </td>
          <td class="whitespace-nowrap py-4 text-sm text-fg-secondary text-left tabular-nums">
            @if (activeTimerStartTime) {
              + {{ activeTimerStartTime | secondsPassed | formatSeconds }}
            }
          </td>
        </tr>
        <tr class="hidden sm:table-row lg:hidden">
          <td
            [colSpan]="3"
            class="whitespace-nowrap px-3 py-4 text-sm font-semibold text-fg-primary text-right"
          >
            Total
          </td>
          <td
            class="whitespace-nowrap px-3 py-4 text-sm font-semibold text-fg-primary text-right tabular-nums"
          >
            {{ totalWorkMinutes | formatWork }}
          </td>
          <td class="whitespace-nowrap py-4 text-sm text-fg-secondary text-left tabular-nums">
            @if (activeTimerStartTime) {
              + {{ activeTimerStartTime | secondsPassed | formatSeconds }}
            }
          </td>
        </tr>
        <tr class="sm:hidden">
          <td
            [colSpan]="2"
            class="whitespace-nowrap px-3 py-4 text-sm font-semibold text-fg-primary text-right"
          >
            Total
          </td>
          <td
            class="whitespace-nowrap px-3 py-4 text-sm font-semibold text-fg-primary text-right tabular-nums"
          >
            {{ totalWorkMinutes | formatWork }}
          </td>
          <td class="whitespace-nowrap py-4 text-sm text-fg-secondary text-left tabular-nums">
            @if (activeTimerStartTime) {
              + {{ activeTimerStartTime | secondsPassed | formatSeconds }}
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  @if (suggestions && suggestions.length > 0) {
    <div class="mt-8">
      <app-work-suggestions [suggestions]="suggestions" (selectSuggestion)="selectSuggestion.emit($event)"></app-work-suggestions>
    </div>
  }
</div>
